<template lang="">
  <div id="footer_page">
    <div class="container">
      <div class="f_content">
        <div class="foot_left">
          <img :src="siteList.footer_logo" alt="">
          <div class="foot_info">
            <span>佛山招商电话：{{siteList.phone}}</span>
            <span>传真：{{siteList.fax}}</span>
            <div>地址：{{siteList.address}}</div>
          </div>
        </div>
        <div class="foot_right">
          <div class="foot_info2">
            <div>
              <ul>
                <li>
                  <router-link to="/">首页</router-link>
                </li>
                <li v-for="(item,index) in navList" :key="index" @mouseenter="setActive(item.id)"
                  @mouseleave="remove(item.id)" :class="{ active: activeIndex === item.id}">
                  <router-link :to="item.path">{{item.title}}</router-link>
                  <div></div>
                </li>
              </ul>
              <span style="margin-top:15px ; display: block; width: 100%; color: #3C4049; text-align: right;">
                {{siteList.copyright}}@2024版权所有 <a target="_blank" style="color: #3C4049;" href="https://beian.miit.gov.cn">{{siteList.icp_number}}</a>
              </span>
            </div>
            <img :src="siteList.code" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        activeIndex: null,// 当前激活的菜单项索引
      }
    },
    props: ['navList', 'siteList'],
    mounted() {

    },
    methods: {
      // 鼠标进入时设置激活索引
      setActive(id) {
        this.activeIndex = id;
        this.activeSec = id;
      },
      // 鼠标离开时清除激活索引
      remove(id) {
        if (this.activeIndex === id) {
          this.activeIndex = null;
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
.active {
    a {
      color: #E60012 !important;

      >div {
        position: absolute;
        left: 50%;
        bottom: 20%;
        transform: translateX(-50%);
        width: 30px !important;
        height: 2px;
        background-color: #E60012;
      }
    }
  }
</style>